import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { MenuOutlined, CloseOutlined } from '@ant-design/icons';
import './LandingPage.css';
import kiplerLogo from './logo_dark.svg';
import HomePage from './Pages/HomePage.js';
import About from './Pages/about.js';
import PrivacyPage from './Pages/PrivacyPage.js'; // <-- NY IMPORT
import CookiePage from './Pages/CookiePage.js';
import CookieBanner from './Components/cookieBanner.js';
import VilkarPage from './Pages/vilkarPage.js';
import ClientsPage from './Pages/clients.js';
import Blog from './Pages/blog.js';
import BlogPost from './Pages/blogPost.js';
import { initGA, trackPageView } from './analytics';
import footerKipler from './Pages/footerKipler.js';



const AppContent = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

  useEffect(() => {
    initGA(); // Initialize GA once
  }, []);

  useEffect(() => {
    trackPageView(location.pathname); // Track on route change
  }, [location]);


  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const NavLinks = ({ closeMenu }) => {
    const location = useLocation();
    const isActive = (path) => (location.pathname === path ? 'selected' : '');

    const handleScrollToPricing = (e) => {
      e.preventDefault();
      const pricingSection = document.getElementById("pris");
      if (pricingSection) {
        pricingSection.scrollIntoView({ behavior: "smooth" });
        if (closeMenu) closeMenu(); // Lukk mobilmenyen etter klikk
      } else {
        window.location.href = "/#pris"; // Fallback for navigasjon fra en annen side
      }
    };

    return (
      <>
        <Link to="/" className={`nav-link ${isActive('/')}`}>
          Hjem
        </Link>
        <Link to="/about" className={`nav-link ${isActive('/about')}`}>
          Om oss
        </Link>
        <a href="#pris" className="nav-link" onClick={handleScrollToPricing}>
          Pris
        </a>
        <Link to="/blog" className={`nav-link ${isActive('/blog')}`}>
          Blogg
        </Link>
        <Button
          type="button"
          className="login-button"
          cursor="pointer"
          onClick={() => window.open('https://app.kipler.ai', '_blank')}
        >
          Logg inn
        </Button>
      </>
    );
  };

  return (
    
      <div>
        {/* Header */}
        <header className="custom-header">
          <div className="header-container">
            <div className="logo">
              <Link to="/">
                <img src={kiplerLogo} alt="Kipler Logo" style={{ cursor: 'pointer' }} />
              </Link>
            </div>
            {/* Desktop Menu */}
            <nav className="nav-links">
              <NavLinks />
            </nav>
            {/* Burger Menu Icon for Mobile */}
            <div className="burger-menu" onClick={toggleMenu}>
              {isMenuOpen ? <CloseOutlined /> : <MenuOutlined />}
            </div>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="mobile-menu">
              <NavLinks />
            </div>
          )}
        </header>

        {/* Routing */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          {/* NY ROUTE for personvern */}
          <Route path="/privacy" element={<PrivacyPage />} />
          {/* NY ROUTE for cookie */}
          <Route path="/cookie" element={<CookiePage />} />
          {/* NY ROUTE for vilkår */}
          <Route path="/vilkar" element={<VilkarPage />} />
          {/* NY ROUTE for klienter */}
          <Route path="/clients" element={<ClientsPage />} />
          {/* Catch-All Route (Fallback til Hjem) */}
          <Route path="*" element={<HomePage />} />
          {/* Blog Routes */}
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>

        {/* Cookie Banner */}
        <CookieBanner />

        {/* Footer */}

          <div>

            {footerKipler()}
          </div>

      </div>
    
  );
};

const App = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;
